var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-refresh.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.83335 6.41672H4.14227L4.14285 6.41147C4.21902 6.03851 4.3681 5.68426 4.58152 5.36905C4.89912 4.90111 5.34461 4.5344 5.86485 4.31264C6.04102 4.23797 6.22477 4.1808 6.41202 4.14289C6.80046 4.06413 7.20075 4.06413 7.58919 4.14289C8.14742 4.25727 8.65966 4.53338 9.0621 4.9368L9.8881 4.11314C9.51583 3.74076 9.07538 3.44349 8.59077 3.23755C8.34362 3.13292 8.08666 3.05319 7.82369 2.99955C7.28109 2.88931 6.72187 2.88931 6.17927 2.99955C5.9161 3.05341 5.65894 3.13334 5.4116 3.23814C4.68275 3.54736 4.05881 4.06069 3.61494 4.7163C3.31621 5.15838 3.1073 5.65488 3.0001 6.17755C2.98377 6.2563 2.97502 6.3368 2.96335 6.41672H1.16669L3.50002 8.75005L5.83335 6.41672ZM8.16669 7.58339H9.85777L9.85719 7.58805C9.70477 8.33575 9.26406 8.99335 8.63044 9.41855C8.31533 9.63215 7.96104 9.78124 7.58802 9.85722C7.19978 9.93597 6.79968 9.93597 6.41144 9.85722C6.03847 9.78105 5.68422 9.63198 5.36902 9.41855C5.21422 9.31384 5.06968 9.1947 4.93735 9.06272L4.11252 9.88755C4.48498 10.2598 4.92564 10.5569 5.41044 10.7626C5.65777 10.8676 5.91619 10.9475 6.17752 11.0006C6.71991 11.1109 7.27896 11.1109 7.82135 11.0006C8.867 10.7835 9.78677 10.1672 10.3851 9.28264C10.6835 8.84089 10.8923 8.34479 10.9994 7.82255C11.0151 7.7438 11.0244 7.6633 11.0361 7.58339H12.8334L10.5 5.25005L8.16669 7.58339Z",
    fill: "#00B45E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxRefresh);
export default __webpack_public_path__ + "static/media/bx-refresh.e7a68e67162f3037b79c766814301d85.svg";
export { ForwardRef as ReactComponent };